"use client";

import { Toaster } from "@/components/ui/toaster";

export default Toaster;
